import { Inject, Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { BuyProductStatus } from './buy-product-status.enum';
import { takeUntil } from 'rxjs/operators';
import { BUY_PRODUCT_GATEWAY } from './buy-product-gateway.token';
import { BuyProductGateway } from './buy-product-gateway.interface';
import { BuyProduct } from './buy-product.entity';

@Injectable({
  providedIn: 'root',
})
export class BuyProductController implements OnDestroy {
  private readonly _buyProductStatus$: BehaviorSubject<BuyProductStatus>;
  private readonly _destroy$ = new Subject<void>();

  constructor(
    @Inject(BUY_PRODUCT_GATEWAY)
    private readonly buyProductGateway: BuyProductGateway,
  ) {
    this._buyProductStatus$ = new BehaviorSubject<BuyProductStatus>(
      BuyProductStatus.INIT,
    );
  }

  public get buyProductStatus$(): Observable<BuyProductStatus> {
    return this._buyProductStatus$.asObservable();
  }

  public setInit(): void {
    this._buyProductStatus$.next(BuyProductStatus.INIT);
  }

  public buyProduct(data: BuyProduct): void {
    this._buyProductStatus$.next(BuyProductStatus.SENDING);

    this.buyProductGateway
      .buyProduct(data)
      .pipe(takeUntil(this._destroy$))
      .subscribe((res) => {
        if (res.success) {
          this._buyProductStatus$.next(BuyProductStatus.SENT);
        } else {
          this._buyProductStatus$.next(BuyProductStatus.ERROR);
        }
      });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
